import { Route, Routes } from 'react-router-dom';
import AllMovieList from '../components/AllMovieList';

import Details from '../components/Details';
import Footer from '../components/Footer';
import MenuHeader from '../components/MenuHeader';
import MovieDetail from '../components/MovieDetail';
import TestComponents from '../components/TestComponents';
import TopHeader from '../components/TopHeader';

import AboutScreen from '../screens/AboutScreen';
import BuyTicket from '../screens/BuyTicket';
import ContactPage from '../screens/ContactPage';
import DownloadScreen from '../screens/DownloadScreen';
import ErrorPage from '../screens/ErrorPage';
import Home from '../screens/Home';
import LoginScreen from '../screens/LoginScreen';
import ShowTime from '../screens/ShowTime';
const routes = [
  {
    path: '/',
    components: Home,
  },

  {
    path: '/login',
    components: LoginScreen,
  },
  {
    path: '/about-cineplex',
    components: AboutScreen,
  },
  {
    path: '/download',
    components: DownloadScreen,
  },

  {
    path: '/movie/:id',
    components: MovieDetail,
  },
  {
    path: '/showtimes',
    components: ShowTime,
  },
  {
    path: '/buy-ticket',
    components: BuyTicket,
  },
  {
    path: '/details/:id',
    components: Details,
  },
  {
    path: '/test',
    components: TestComponents,
  },
  {
    path: '/movies/:type',
    components: AllMovieList,
  },
  {
    path: '/contacts',
    components: ContactPage,
  },
  {
    path: '/*',
    components: ErrorPage,
  },
];

const TerritoryApplication = () => {
  //   const arr = useMemo(() => routes, [routes]);

  // const userLogin = useSelector((state) => state.userLogin);
  // if (!userLogin?.token?.access_token) {
  //   return <LoginScreen />;
  // }
  return (
    <>
      <TopHeader />
      <MenuHeader />
      <Routes>
        {routes?.map((r, index) => {
          return (
            <Route
              key={index}
              path={r?.path}
              element={<r.components />}
            />
          );
        })}
      </Routes>
      <Footer />
    </>
  );
};

export default TerritoryApplication;
